import React, { useState } from 'react';
import { Box, Button, Flex, Text } from '@chakra-ui/react';
import { ArrowBackIcon, AddIcon } from '@chakra-ui/icons';
import ReusableTable from 'components/ReusableTable';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import useDebounce from 'constants/helper/useDebounce';
import SavedDiseaseProtocolForm from './savedDiseaseProtocolForm';
import { savedDiseaseProtocolList } from 'api/auth.api';

function SavedDiseaseProtocol() {
  const [showForm, setShowForm] = useState(false);
  const [page, setPage] = useState(1);
  const [searchString, setSearchString] = useState('');
  const debouncedSearchTerm = useDebounce(searchString, 1000, setPage);
  const queryClient = useQueryClient();
  const [selectedId, setSelectedId] = useState(null);

  const payload = {
    searchString: debouncedSearchTerm,
    page,
  };

  const { data, isFetching } = useQuery({
    queryKey: ['savedDiseaseProtocolList', debouncedSearchTerm, page],
    queryFn: () => savedDiseaseProtocolList(payload),
    keepPreviousData: true,
    refetchOnWindowFocus: false,
  });

  const tableData = data?.data?.result?.map((item, index) => ({
    ...item,
    srNo: (page - 1) * 20 + index + 1,
  }));

  const formattedData = tableData?.map((item) => {
    const diseases = item.diseases || [];

    const engList = diseases.map((d) => d.diseaseEnglish).filter(Boolean);
    const hindList = diseases.map((d) => d.diseaseHindi).filter(Boolean);

    const bottle1Values = [
      item?.bottle1?.E,
      item?.bottle1?.R1,
      item?.bottle1?.R2,
    ].filter((v) => v !== undefined && v !== null && v !== '');

    const bottle2Values = [
      item?.bottle2?.E,
      item?.bottle2?.R1,
      item?.bottle2?.R2,
    ].filter((v) => v !== undefined && v !== null && v !== '');
    const bottle3Values = [
      item?.bottle3?.E,
      item?.bottle3?.R1,
      item?.bottle3?.R2,
    ].filter((v) => v !== undefined && v !== null && v !== '');
    const bottle4Values = [
      item?.bottle4?.E,
      item?.bottle4?.R1,
      item?.bottle4?.R2,
    ].filter((v) => v !== undefined && v !== null && v !== '');

    return {
      ...item,

      bottle1:
        bottle1Values.length > 1
          ? bottle1Values.join(' + ')
          : bottle1Values[0] || '- - -',
      bottle2:
        bottle2Values.length > 1
          ? bottle2Values.join(' + ')
          : bottle2Values[0] || '- - -',
      bottle3:
        bottle3Values.length > 1
          ? bottle3Values.join(' + ')
          : bottle3Values[0] || '- - -',
      bottle4:
        bottle4Values.length > 1
          ? bottle4Values.join(' + ')
          : bottle4Values[0] || '- - -',

      diseaseEng: engList.length > 1 ? engList.join(' / ') : engList[0] || '',

      diseaseHind:
        hindList.length > 1 ? hindList.join(' / ') : hindList[0] || '',
    };
  });

  const handleSearch = (value) => {
    setSearchString(value);
  };

  return (
    <Box p={4} mt={10}>
      {!showForm && (
        <ReusableTable
          data={formattedData}
          columns={[
            { key: 'srNo', label: 'Sr.No', width: '80px', headerSize: '14px' },

            {
              key: 'diseaseEng',
              label: 'Disease Name Eng',
              width: '300px',
              headerSize: '14px',
            },
            {
              key: 'diseaseHind',
              label: 'Disease Name Hin',
              width: '300px',
              headerSize: '14px',
            },
            {
              key: 'bottle1',
              label: 'Bottle 1',
              width: '400px',
              headerSize: '14px',
            },
            {
              key: 'bottle2',
              label: 'Bottle 2',
              width: '400px',
              headerSize: '14px',
            },
            {
              key: 'bottle3',
              label: 'Bottle 3',
              width: '400px',
              headerSize: '14px',
            },
            {
              key: 'bottle4',
              label: 'Bottle 4',
              width: '400px',
              headerSize: '14px',
            },
          ]}
          page={page}
          totalPages={data?.data?.totalPages || 1}
          showSearch={true}
          onSearch={handleSearch}
          loading={isFetching}
          onRowClick={() => {}}
          // onEdit={(id) => {
          //   setSelectedId(id);
          //   setShowForm(true);
          // }}
          onPageChange={(newPage) => setPage(newPage)}
          showTopAction={true}
          showAddBtn={false}
          topAction={{
            title: 'Saved Disease Protocol Form OPD Page',
            label: 'Add Protocol',
            icon: <AddIcon />,
            onClick: () => setShowForm(true),
          }}
          showViewToggle={false}
        />
      )}

      {showForm && (
        <Box w="100%">
          <Flex
            flexDirection="row"
            justifyContent="space-between"
            alignItems="center"
            gap={4}
            mb={4}
            ml={3}
          >
            <Text fontSize="22px" fontWeight="bold">
              Saved Disease Protocol
            </Text>
            <Button
              variant="ghost"
              leftIcon={<ArrowBackIcon />}
              onClick={() => {
                setShowForm(false);
                setSelectedId(null);
              }}
            >
              Back
            </Button>
          </Flex>

          <SavedDiseaseProtocolForm
            editId={selectedId}
            onSuccess={() => {
              queryClient.invalidateQueries(['diseaseProtocolList']);
              setShowForm(false);
            }}
          />
        </Box>
      )}
    </Box>
  );
}

export default SavedDiseaseProtocol;
